import { autocompletion, completionKeymap } from "@codemirror/autocomplete";
import { Prec, type Extension } from "@codemirror/state";
import { keymap } from "@codemirror/view";
import { slashSource } from "./slashMenu.ts";
import { linkSource } from "./linkMenu.ts";
import { type LinkUIOptions } from "./linkUI.ts";

/**
 * El único `autocompletion()` del editor de documentos.
 *
 * Existe porque las fuentes son dos —el menú de bloques con `/` y el buscador
 * de documentos con `[[`— y CodeMirror admite un solo `override`: registrar
 * `autocompletion()` dos veces deja una de las dos fuentes sin efecto, según
 * cuál gane la configuración. Juntándolas acá el popup es uno, y agregar una
 * tercera es sumarla a esta lista.
 */
export function completions(opts: LinkUIOptions): Extension {
  return [
    autocompletion({
      override: [slashSource(opts), linkSource(opts)],
      activateOnTyping: true,
      icons: true,
      closeOnBlur: true,
    }),
    // Above the default keymap so Enter picks the option instead of a newline.
    Prec.high(keymap.of(completionKeymap)),
  ];
}
